/**
 * 理疗模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取理疗列表(过滤掉已被禁用的理疗项目)
export const physioList = (params) => {
  return req.get('/hosp/physio/list', params);
}

// 获取理疗列表(所有理疗项目)
export const physioListAll = (params) => {
  return req.get('/hosp/physio/listNew', params);
}

// 获取理疗类型列表
export const physioKindList = (params) => {
  return req.get('/hosp/physio/kind/list', params);
}

// 获取理疗类型列表
export const changeEnableStatus = (params) => {
  return req.post('/hosp/physio/editEnableStatus', params);
}

// 根据药品种类查询药品
export const physioListDetails = (params) => {
  return req.get('/hosp/physio/selectListByKindId', params);
}
// 根据药品种类查询药品
export const edit = (params) => {
  return req.post('/hosp/physio/edit', params);
}
// 获取理疗执行周期
export const getPhysioIntervalEnum = (params) => {
  return req.get('/hosp/physio/getPhysioIntervalEnum', params);
}
//校验理疗项目必填项
export const checkPhysioConfig = (params) => {
  return req.post('/hosp/physio/checkPhysioConfig', params);
}
// 获取理疗列表(所有理疗项目)
export const queryPhysio = (params) => {
  return req.get('/hosp/physio/queryPhysio', params);
}
// ================(2025-07)理疗预约接口===================
// ------理疗分类接口------
export const getPhysioCategoryList = (params) => {
  return req.get('/physioCategory/queryChildCategorys', params)
}

export const getPhysioCategoryDetail = (params) => {
  return req.get('/physioCategory/queryCategory', params)
}

export const postPhysioCategory = (params) => {
  return req.post('/physioCategory/addCategory', params)
}

export const putPhysioCategory = (params) => {
  return req.post('/physioCategory/updateCategory', params)
}

export const deletePhysioCategory = (params) => {
  return req.post('/physioCategory/removeCategory', params)
}

// ------理疗项目配置接口------
export const getPhysioConfigList = (params) => {
  return req.get('/physioConfig/queryConfigPage', params)
}

export const getPhysioConfigByArtNo = (params) => {
  return req.get('/physioConfig/queryConfig', params)
}

export const postPhysioConfig = (params) => {
  return req.post('/physioConfig/editConfig', params)
}

// ------理疗项目组合接口------
export const getPhysioCombinationList = (params) => {
  return req.get('/physioCombination/queryCombinations', params)
}

export const getPhysioCombinationById = (params) => {
  return req.get('/physioCombination/queryCombination', params)
}

export const postPhysioCombination = (params) => {
  return req.post('/physioCombination/addCombination', params)
}

export const putPhysioCombination = (params) => {
  return req.post('/physioCombination/editCombination', params)
}

export const deletePhysioCombination = (params) => {
  return req.post('/physioCombination/removeCombination', params)
}

// ------理疗项目权限配置接口------
export const getPhysioPowerList = (params) => {
  return req.get('/physioDoctorTemplate/queryDoctorTemplatePage', params)
}

export const getPhysioPowerDetail = (params) => {
  return req.get('/physioDoctorTemplate/queryDoctorTemplate', params)
}

export const postPhysioPower = (params) => {
  return req.post('/physioDoctorTemplate/editDoctorTemplate', params)
}

// ------理疗预约看板接口------
export const getPhysioReservationBoard = (params) => {
  return req.get('/physioReservation/queryReservationNoticeBoards', params)
}

// ------理疗执行接口------
export const getTodayReservations = (params) => {
  return req.get('/physioReservation/queryTodayReservations', params)
}

// ------理疗预约接口------
export const getReservationScheduling = (params) => {
  return req.post('/physioReservation/queryPlatFormReservationSchedulingItem', params)
}

export const postPhysioReservation = (params) => {
  return req.post('/physioReservation/reservationPlatform', params)
}

export const getPhysioProcutions = (params) => {
  return req.get('/physioReservation/queryPhysioByName', params)
}

export const getPhysioTrilateralReservationScheduling = (params) => {
  return req.post('/physioReservation/queryTrilateralReservationSchedulingItem', params)
}

export const postPhysioTrilateralReservation = (params) => {
  return req.post('/physioReservation/reservationTrilateral', params)
}

export const getTrilateralReservationRecord = (params) => {
  return req.get('/physioReservation/queryTrilateralReservationPage', params)
}

export const getAccountPhysioProperty = (params) => {
  return req.get('/physio/accountPhysioProperty', params)
}

export const queryReservationAppletCard = (params) => {
  return req.get('/physioReservation/queryReservationAppletCard', params)
}

export const getReservationDetailByPatientId = (params) => {
  return req.get('/physioReservation/queryReservationDetailByPatientId', params)
}
export const editPhysio = (params) => {
  return req.post('/hosp/physio/editNew', params)
}
export const editDrugPriceConfigDetail = (params) => {
  return req.post('/hosp/drugPriceConfig/editDrugPriceConfigDetail', params)
}
